const calcAnnualInsuranceCost = (vehicleBasePurchaseCost, passangerCargo = false) =>
  vehicleBasePurchaseCost * 0.1 * 0.76 * (passangerCargo ? 3 : 1);
// 0.76 above is the state index for California; do not reuse for other states

export default calcAnnualInsuranceCost;
